import { FunctionComponent, useMemo } from "react";
import { matchPath, Outlet, useLocation } from "react-router-dom";

import { IBreadcrumbItem } from "@bps/fluent-ui";
import { Breadcrumbs } from "@components/breadcrumbs/Breadcrumbs";
import { getDefaultBreadcrumbItems } from "@components/breadcrumbs/breadcrumbs.utils";
import { useBpIdUserDetails } from "@libs/api/gateways/bp-id/bp-id.hooks";

import { getBpIdUserName } from "./business-users/account-view/account-view.utils";
import { UsersTabs } from "./users-tabs.constants";

export const UsersBreadcrumbs: FunctionComponent = () => {
  const { pathname } = useLocation();
  const objectId = matchPath(
    `/users/${UsersTabs.BusinessUsers.IdentitySearch.id}/:objectId`,
    pathname
  )?.params.objectId;

  // Shares the account view's query cache, so no extra request is made.
  const { data: bpIdUser } = useBpIdUserDetails(objectId!, {
    enabled: !!objectId
  });

  const items = useMemo<IBreadcrumbItem[]>(() => {
    const _items = getDefaultBreadcrumbItems(UsersTabs, pathname);
    if (objectId) {
      _items[_items.length - 1] = {
        key: objectId,
        text: bpIdUser ? getBpIdUserName(bpIdUser) || objectId : "..."
      };
    }
    return _items;
  }, [pathname, objectId, bpIdUser]);

  return (
    <>
      <Breadcrumbs items={items} marginBottom={0} />
      <Outlet />
    </>
  );
};
